import { render } from "./ShippingMethodCustomers.vue?vue&type=template&id=71c85dde&scoped=true&ts=true"
import script from "./ShippingMethodCustomers.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodCustomers.vue?vue&type=script&lang=ts"

import "./ShippingMethodCustomers.vue?vue&type=style&index=0&id=71c85dde&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c85dde"]])

export default __exports__